import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { toast } from 'react-toastify';
import { KIWISTRON_LOGO, KIWISTRON_APP_NAME, KIWISTRON_BRAND_NAME } from '../constants/brand';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      // Call actual backend login from AuthContext
      const u = await login(email.trim(), password);
      const isAdmin = String(u?.role || '').toLowerCase().includes('admin');
      toast.success(
        isAdmin ? `Welcome, ${u?.name || 'Admin'}!` : `Welcome, ${u?.name || 'there'}! Employee portal ready.`
      );
      navigate('/admin');
    } catch (err) {
      console.error(err);
      toast.error(
        err.response?.data?.message ||
          'Login failed. Use full email from Users tab and the same password you saved.'
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'linear-gradient(135deg, #0f172a 0%, #172554 50%, #1e3a8a 100%)',
      fontFamily: "'Inter', sans-serif",
      position: 'relative',
      overflow: 'hidden'
    }}>
      {/* Background Orbs */}
      <div style={{ position: 'absolute', width: '300px', height: '300px', borderRadius: '50%', background: 'rgba(2, 132, 199, 0.28)', filter: 'blur(50px)', top: '-100px', right: '-100px' }}></div>
      <div style={{ position: 'absolute', width: '400px', height: '400px', borderRadius: '50%', background: 'rgba(30, 64, 175, 0.22)', filter: 'blur(80px)', bottom: '-150px', left: '-150px' }}></div>

      <div style={{
        background: 'rgba(255, 255, 255, 0.05)',
        backdropFilter: 'blur(20px)',
        border: '1px solid rgba(255, 255, 255, 0.1)',
        borderRadius: '24px',
        padding: '3rem',
        width: '100%',
        maxWidth: '400px',
        boxShadow: '0 25px 50px rgba(0, 0, 0, 0.3)',
        color: '#ffffff'
      }}>
        <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
          <img
            src={KIWISTRON_LOGO}
            alt={`${KIWISTRON_BRAND_NAME} logo`}
            className="login-brand-logo"
          />
          <h2 style={{ fontWeight: 800, fontSize: '1.75rem', marginBottom: '0.35rem', letterSpacing: '-0.02em' }}>
            {KIWISTRON_BRAND_NAME}
            <span style={{ fontWeight: 600, color: '#94a3b8' }}> {KIWISTRON_APP_NAME}</span>
          </h2>
          <p style={{ color: '#94a3b8', fontSize: '0.875rem' }}>Admin &amp; Employee Login</p>
        </div>

        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: '1.5rem' }}>
            <label style={{ display: 'block', fontSize: '0.75rem', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.05em', color: '#cbd5e1', marginBottom: '0.5rem' }}>Email Address</label>
            <div style={{ position: 'relative' }}>
              <i className="bi bi-envelope" style={{ position: 'absolute', left: '1rem', top: '50%', transform: 'translateY(-50%)', color: '#64748b' }}></i>
              <input 
                type="email" 
                className="form-control" 
                style={{
                  background: 'rgba(255, 255, 255, 0.05)',
                  border: '1px solid rgba(255, 255, 255, 0.1)',
                  borderRadius: '12px',
                  padding: '0.75rem 1rem 0.75rem 2.5rem',
                  color: '#ffffff',
                  fontSize: '0.875rem'
                }}
                placeholder="ananthi.kiwistron@gmail.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                autoComplete="email"
                required
              />
            </div>
          </div>

          <div style={{ marginBottom: '1.5rem' }}>
            <label style={{ display: 'block', fontSize: '0.75rem', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.05em', color: '#cbd5e1', marginBottom: '0.5rem' }}>Password</label>
            <div style={{ position: 'relative' }}>
              <i className="bi bi-lock" style={{ position: 'absolute', left: '1rem', top: '50%', transform: 'translateY(-50%)', color: '#64748b' }}></i>
              <input 
                type={showPassword ? "text" : "password"} 
                className="form-control" 
                style={{
                  background: 'rgba(255, 255, 255, 0.05)',
                  border: '1px solid rgba(255, 255, 255, 0.1)',
                  borderRadius: '12px',
                  padding: '0.75rem 2.5rem 0.75rem 2.5rem',
                  color: '#ffffff',
                  fontSize: '0.875rem'
                }}
                placeholder="••••••••"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                autoComplete="current-password"
                required
              />
              <i 
                className={`bi ${showPassword ? 'bi-eye-slash' : 'bi-eye'}`} 
                onClick={() => setShowPassword(!showPassword)}
                style={{ position: 'absolute', right: '1rem', top: '50%', transform: 'translateY(-50%)', cursor: 'pointer', color: '#64748b' }}
              ></i>
            </div>
          </div>

          <button 
            type="submit" 
            style={{
              width: '100%',
              background: 'linear-gradient(135deg, #1e40af, #1e3a8a)',
              border: 'none',
              padding: '0.75rem',
              borderRadius: '12px',
              color: '#ffffff',
              fontWeight: 600,
              fontSize: '0.875rem',
              cursor: 'pointer',
              transition: 'all 0.2s',
              boxShadow: '0 4px 12px rgba(30, 64, 175, 0.4)'
            }}
            disabled={loading}
          >
            {loading ? 'Signing in...' : 'Sign In'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;
